import { EventScopeType, type EventSearchResult, EventSearchResultSchema } from '@scoring/types';
import { post } from '../../../queries';
import { queryKeys } from '../../../queries/queryKeys';
import { useApiQuery } from '../../../queries/useApiQuery';

//Events in any state where the caller judges a competition
export const useJudgingEventsQuery = (enabled = true) =>
    useApiQuery<EventSearchResult>({
        queryKey: queryKeys.events.search(EventScopeType.Judging),
        queryFn: () => post('events/search', { scope: EventScopeType.Judging }, EventSearchResultSchema),
        // a judge waiting for an event can miss the stream, e.g. a heat opening only reaches the event's group
        queryOptions: { enabled, refetchInterval: 10_000 },
    });

//Events the caller owns or contributes to; admins get every event
export const useEditableEventsQuery = () =>
    useApiQuery<EventSearchResult>({
        queryKey: queryKeys.events.search(EventScopeType.Editable),
        queryFn: () => post('events/search', { scope: EventScopeType.Editable }, EventSearchResultSchema),
    });

//Events in any state where the caller is head judge on a heat that is still open for judging
export const useHeadJudgeableEventsQuery = (poll = false) =>
    useApiQuery<EventSearchResult>({
        queryKey: queryKeys.events.search(EventScopeType.HeadJudgeable),
        queryFn: () => post('events/search', { scope: EventScopeType.HeadJudgeable }, EventSearchResultSchema),
        // only the waiting screen polls, in case it misses the stream; a head judge whose last heat finished
        // shouldn't be thrown out mid-review
        queryOptions: { refetchInterval: poll ? 10_000 : undefined },
    });
